import * as React from 'react';
import CodeField from '../ts/CodeField';

import { IGlob } from '../../application/ts/Glob';

export class EditTargetDialog extends React.Component<
    {
        setConfirmValueGetter(getConfirmValue);
        unsetConfirmValueGetter?();
        options: any;
        glob: IGlob;
    },
    any
> {
    constructor(props) {
        super(props);

        this.state = {
            data: ''
        };
    }

    private getConfirmValue = () => {
        return this.state.data;
    };

    componentWillMount() {
        const obj = this.props.setConfirmValueGetter(this.getConfirmValue);
        const val = this.props.glob.AppStore.getFromLocalStorage('pdc_clipboard_editdata');

        this.setState({
            data: val
        });
    }

    componentWillUnmount() {
        if (typeof this.props.unsetConfirmValueGetter === 'function') {
            this.props.unsetConfirmValueGetter();
        }
    }

    private handleDataChange = (val) => {
        this.setState({
            data: val
        });
    };

    render() {
        const Component = CodeField.EditComponent;
        var theme = this.props.options && this.props.options.theme ? this.props.options.theme : {};
        return (
            <div className="export-params">
                <div>
                    <Component
                        value={this.state.data}
                        onChange={this.handleDataChange}
                        wordWrap={true}
                        setFocus={true}
                        theme={theme}
                        initialHeight={420}
                        dataSourceID={this.props.options.dataSourceID}
                        showFuncList={false}
                        showAttrList={true}
                        putAttrAsArray={false}
                        glob={this.props.glob}
                    />
                </div>
            </div>
        );
    }
}
